export default "__VITE_ASSET__Ad4S$uCF__"